<template>
    <div id="indexChartLine"></div>
</template>

<script>
 import * as echarts from "echarts";
export default {
    name: 'index-line-chart',
    props: {
        collapsed: {
            type: Boolean,
        },
        rateStaticData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
    return {
        str:{
            normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(78, 163, 248, 1)'
                }, {
                    offset: 1,
                    color: 'rgba(78, 163, 64, 0.1)'
                }])
            }
        }
    }
    },
    mounted () {
        var _this=this;
        window.addEventListener("resize", ()=>{
            if(_this.chartLine!=null){
                _this.chartLine.resize();
            }
        })
        this.drawLineChart();
    },
    watch: {
        'collapsed': {
            handler (val) {
                if(this.chartLine!=null){
                    this.chartLine.resize();
                }
            },
            deep: true
        },
        'rateStaticData': {
            handler (val) {
                this.drawLineChart();
            },
            deep: true
        }
    },
    methods: {
        drawLineChart:function() {
            if(this.rateStaticData.xdata==undefined||this.rateStaticData.xdata.length==0){
                return;
            }
            this.chartLine = echarts.init(document.getElementById('indexChartLine'));

            let option = {
                legend: {
                    data: ['昼间','夜间'],
                    x: '60%',
                    y: '9%'
                },
                xAxis: {
                    name:'功能区',
                    type: 'category',
                    data: this.rateStaticData.xdata
                },
                yAxis: {
                    name:'达标率(%)',
                    type: 'value'
                },
                grid: {
                    top: 50,
                    left: 20,
                    right:70,
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function(params) {
                        var result = params[0].seriesName+':'+ params[0].data+'%</br>'
                                    +params[1].seriesName+':'+ params[1].data+'%';
                        return result;
                    },
                },
                series: [{
                    name: '昼间',
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                        normal: {
                        color: '#4DA2F7'
                        }
                    },
                    areaStyle: this.str,
                    data: this.rateStaticData.dayData
                },
                {
                    name: '夜间',
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                        normal: {
                        color: '#ED8A46'
                        }
                    },
                    areaStyle: this.str,
                    data: this.rateStaticData.nightData
                }]
            }
            this.chartLine.setOption(option,true)
        },
    }
}
</script>

<style lang="scss">
#indexChartLine{
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// IndexLineChart.vue?4841ba8d